import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/magento/src/utils/useGraphQLDebug.ts");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/mindbox/src/lib/MindboxPageView.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/api/mindbox/src/lib/scriptMindbox.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/account/page/loyalty/src/components/AccrualHistory/AccrualHistory.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/account/page/loyalty/src/components/Achievements/Achievements.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/account/page/loyalty/src/components/Banner/Banner.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/account/page/loyalty/src/components/Faq/Faq.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/account/page/loyalty/src/components/MainInfo/MainInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ArticlePageContent"] */ "/app/packages/libs/fo/feature/article/page/newsandpromo/src/components/ArticlePageContent/ArticlePageContent.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/help/page/base/src/components/ContactInfo/ContactInfo.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/help/page/base/src/lib/FeatureHelpPageBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/product/catalog/base/src/lib/FeatureProductCatalogBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/product/catalog/base/src/util/parseAsObject.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ProductPageClient"] */ "/app/packages/libs/fo/feature/product/page/base/src/components/ProductPageClient/ProductPageClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/feature/product/tile/base/src/lib/FeatureProductTileBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/icons/base/src/icons/arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/kit/animation/base/src/lib/UiKitAnimationBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/kit/banner/hero/src/lib/UiKitBannerHero.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/kit/carousel/base/src/lib/UiKitCarouselBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/kit/panel/base/src/lib/UiKitPanelBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/kit/section/important-projects/src/lib/UiKitSectionImportantProjects.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/kit/section/seo-text/src/lib/UiKitSectionSeoText.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/mod/footnote/base/src/lib/UiModFootnoteBase.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/product/info/video/src/lib/UiProductInfoVideo.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/product/layout/catalog/src/components/SortBlock/SortBlock.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/libs/fo/ui/product/layout/catalog/src/lib/UiProductLayoutCatalog.tsx");
